// Node Module Imports
import { css } from 'styled-components'

const sizes = {
  lg: 992,
  md: 768,
  sm: 576,
  tiny: 374,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
}

export const above = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `
  return acc as Record<keyof typeof sizes, Function>
}, {} as Record<keyof typeof sizes, Function>)

export const below = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] - 1}px) {
      ${css(...args)}
    }
  `
  return acc as Record<keyof typeof sizes, Function>
}, {} as Record<keyof typeof sizes, Function>)
